export enum LocalStorageKeys {
  VoucherCodeSubsidy = "voucherCodeSubsidy",
  AffiliateCode = "affiliateCode",
  RoleIntent = "roleIntent",
  SelectedPaypoint = "selectedPaypoint",
  CampaignTransactions = "campaign_transactions",
  QuickPaymentAttempted = "quickPaymentAttempted",
  TransactionFilters = "transactionFilters",
  CustomerTransactionFilters = "customerTransactionFilters",
  CardTransactionFilters = "cardTransactionFilters",
  BetaDrawerSeen = "betaDrawerSeen",
  DashboardBalanceCurrency = "dashboardBalanceCurrency",
  /** "on" | "off"; unset = the persona never reached the chat gate on this device (native shells only). */
  ChatPushPreference = "chatPushPreference",
  /**
   * Last push token (APNs on iOS, FCM on Android) registered with Stream from this device (native
   * shells only). The stored string keeps its historical APNs name: renaming it would orphan the
   * tokens already stored on iOS devices, and logout could no longer remove them from Stream.
   */
  ChatPushDeviceToken = "chatPushApnsToken",
  /**
   * `{ nonce, expiresAt }` issued when the Android shell starts the browser-redirect Apple
   * sign-in; consumed once by /auth/apple to validate Apple's `state`. localStorage on purpose:
   * the return may arrive after the OS killed the app process, which empties sessionStorage.
   */
  AppleSignInState = "appleSignInState",
}

// (string & {}) keeps enum autocomplete while still allowing dynamic keys like `quickPaymentAttempted_${id}`.
export type LocalStorageKey = LocalStorageKeys | (string & {});
